import React from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';

import type { StatusActivityAction } from '@shared/patient-intake-status';

import { useAuth } from '../../../../hooks/index.js';
import { CopyButton } from '../../../../components/ui/CopyButton.jsx';
import type { TimelineItem } from './HistoryDialog.types.ts';
import { TimelineItemSection } from './TimelineItemSection.tsx';

type ActionedBySectionProps = {
  item: TimelineItem<StatusActivityAction>;
};

export const ActionedBySection: React.FC<ActionedBySectionProps> = ({ item }) => {
  const { user } = useAuth();

  if (!item.actionedBy) {
    return null;
  }

  const isCurrentUser = item.actionedBy.id === user?.uid;

  if (isCurrentUser) {
    return (
      <TimelineItemSection
        title="Actioned by"
        Icon={Person2RoundedIcon}
        flexDirection="row"
        justifyContent="space-between"
      >
        <Typography variant="caption">This update was made by you</Typography>
      </TimelineItemSection>
    );
  }

  return (
    <TimelineItemSection title="Actioned by" Icon={Person2RoundedIcon}>
      <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" justifyContent="space-between">
        <CopyButton noHighlight textToCopy={item.actionedBy.name || item.actionedBy.email} color="inherit">
          <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
            {item.actionedBy.userType}
          </Typography>
          <Divider orientation="vertical" flexItem />
          <Typography variant="body2">{item.actionedBy.name || item.actionedBy.email}</Typography>
        </CopyButton>
        <CopyButton
          noHighlight
          alwaysShowIcon
          color="inherit"
          title={`Copy ID - ${item.actionedBy.id}`}
          textToCopy={item.actionedBy.id}
        >
          <Typography variant="caption">Copy User ID</Typography>
        </CopyButton>
      </Stack>
    </TimelineItemSection>
  );
};
